<template>
  <div class="pub-page">
    <div class="pub-header d-flex align-items-center justify-content-between">
      <div>
        <text class="title me-1">{{$route.meta.title}}</text>
      </div>

      <el-button type="primary"  class="ms-2 me-3" @click="handleExport">导出</el-button>
    </div>
    <div class="pub-center pt-2" >
      <div class="search--box">
        <el-form-item label="年份：" class="me-3">
<!--          <el-input v-model="params.year" style="width: 100px"/>-->
          <el-select v-model="params.year" style="width: 100px" clearable>
            <el-option v-for="i of YEARS" :key="i.ID" :value="i.ID" :label="i.Name" />
          </el-select>
        </el-form-item>
        <el-form-item label="省份：" class="me-3" >
<!--          <el-input v-model="params.province" placeholder="请选择" style="width: 100px"/>-->
          <el-select v-model="params.province" style="width: 150px" clearable filterable>
            <el-option v-for="i of provinces" :key="i" :value="i" :label="i" />
          </el-select>

        </el-form-item>
        <el-form-item label="所属大学："  class="me-3">
<!--          <el-input v-model="params.name" style="width: 100px" clearable/>-->
          <el-select v-model="params.university_id" style="width: 150px" clearable filterable>
            <el-option v-for="i of schools" :key="i.ID" :value="i.ID" :label="i.Name" />
          </el-select>
        </el-form-item>
        <el-form-item label="参赛组别：" class="me-3" >
<!--          <el-input v-model="params.level" style="width: 100px"/>-->
          <el-select v-model="params.level" style="width: 100px" clearable>
            <el-option v-for="i of LEVELS" :key="i.ID" :value="i.ID" :label="i.Name" />
          </el-select>

        </el-form-item>
        <el-form-item label=""  >
          <el-input placeholder="队名/联系人姓名/手机号" v-model="params.keyword" class="ms-3 me-1"/>
        </el-form-item>
        <el-button type="primary"  @click="getList(true)">搜索</el-button>
        <el-button type=""  @click="reset">重置</el-button>
      </div>

      <el-table border scrollbar-always-on  :data="list" style="width: calc(100% - 30px);height:calc(100% - 60px);position: absolute;left: 15px;top:50px;padding-bottom: 30px"  v-loading="loading">
        <el-table-column label="年份"  min-width="80px" show-overflow-tooltip >
          <template #default="scope">
            {{scope.row.Year|| '-'}}
          </template>
        </el-table-column>
        <el-table-column label="参赛队名"  min-width="200px" show-overflow-tooltip >
          <template #default="scope">
            {{scope.row.Name || '-'}}
          </template>
        </el-table-column>
        <el-table-column label="省份"  min-width="150px" show-overflow-tooltip >
          <template #default="scope">
            {{scope.row.Province || '-'}}
          </template>
        </el-table-column>
        <el-table-column label="所属大学"  min-width="200px" show-overflow-tooltip >
          <template #default="scope">
            {{scope.row.SchoolName || '-'}}
          </template>
        </el-table-column>
        <el-table-column label="参赛组别" min-width="100px" show-overflow-tooltip>
          <template #default="scope">
            {{scope.row.LevelName || '-'}}
          </template>
        </el-table-column>
        <el-table-column label="联系人姓名" min-width="100px" show-overflow-tooltip>
          <template #default="scope">
            {{scope.row.Contact || '-'}}
          </template>
        </el-table-column>
        <el-table-column label="联系人手机号" min-width="120px" show-overflow-tooltip>
          <template #default="scope">
            {{scope.row.Phone || "-"}}
          </template>
        </el-table-column>
        <el-table-column label="邮箱" min-width="200px" show-overflow-tooltip>
          <template #default="scope">
            {{scope.row.Email || "-"}}
          </template>
        </el-table-column>
        <el-table-column label="联系地址" min-width="200px" show-overflow-tooltip>
          <template #default="scope">
            {{scope.row.Address || "-"}}
          </template>
        </el-table-column>
        <el-table-column label="邮政编码" min-width="100px" show-overflow-tooltip>
          <template #default="scope">
            {{scope.row.PostalCode || "-"}}
          </template>
        </el-table-column>
        <el-table-column label="创建时间" min-width="170px" show-overflow-tooltip>
          <template #default="scope">
            {{scope.row.CreatedTime || "-"}}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100px" fixed="right">
          <template #default="scope">
            <el-button  size="small"  type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pub-footer d-flex align-items-center justify-content-center">
      <el-pagination  v-show="total>0" background
                      layout="total, sizes, prev, pager, next"
                      :page-sizes="[10, 20, 30, 40]"
                      :total="total"
                      v-model:current-page="params.current"
                      @size-change="handleSizeChange"
                      @current-change="handleCurrentChange"/>
    </div>

</div>
</template>

<script setup>
import {onMounted, reactive, ref} from "vue";
import {ElMessage, ElMessageBox} from "element-plus";
import {formatTime} from "@/utils/dateFun";

import {exportTeams, getTeams, removeTeam} from "@/api/teamsAdmin";
import {getName, LEVELS} from "@/utils/commonSetting";
import {getYears} from "@/utils/commonSetting"
import {getProvinces, getSchoolList} from "@/api/school";
import {downLoadWithoutBaseUrl} from "@/utils/downloadFiles";
import {needInitQueryFun} from "@/utils/common";
const YEARS = getYears()
const provinces = ref([]) // 省份列表
const schools = ref([]) // 学校列表
const params = reactive({
  pageSize:10,
  current:1,
  keyword:null, // 队伍名称
  level:null, // 组别
  university_id:null, // 大学id
  year:null, // 年份
  province:null, // 省份
})
const total = ref(0)
const list = ref([])
const loading = ref(false)

onMounted(()=>{
  getProvincesAll() // 获取所有的省份列表
  getSchoolAll() // 获取所有的省份列表
  getList()
})
const reset = ()=>{
  params.current = 1
  params.keyword = ""
  params.level = ""
  params.university_id = ""
  params.year = ""
  params.province = ""
  getList(true)
}
// 删除
const handleDelete = (number,item)=>{
  ElMessageBox.alert('队伍关联的队员和指导老师将一并删除，确定要删除该队伍吗？', '删除', {
    confirmButtonText: '确定',
    callback: (action) => {
      if(action==='confirm'){ // 确定
        const needInitQuery = needInitQueryFun(total.value,params.pageSize,number)
        removeTeam({ids:[item.ID]}).then(res=>{
          if(res.err_code === 0){
            ElMessage.success(`删除成功`)
            getList(needInitQuery) // 重新请求
          }else{
            ElMessage.error(res.err_msg ||`删除失败,请稍后再试`)
          }
        })
      }
    },
  })
}
// 获取省份列表
const getProvincesAll = async ()=>{
  const res = await getProvinces()
  if(res.success){
    provinces.value = res.data || []
  }
}
// 获取所有学校
const getSchoolAll = async ()=>{
  const res = await getSchoolList({pageSize:10000,current:1})
  if(res.success){
    schools.value = res.data || []
  }
}
// 列表
const getList = async (init)=>{
  if(init){
    params.current = 1
  }
  loading.value = true
  const res = await getTeams(params)
  loading.value = false
  if(res.success){
    total.value = res.total
    let data = res.data || []
    data.forEach(item=>{
      if(item.University){
        item.Province = item.University.Province
        item.SchoolName = item.University.Name
      }
      if(item.Level){
        item.LevelName = getName(LEVELS,item.Level)
      }
      //  创建时间
      if(item.CreatedAt){
        item.CreatedTime = formatTime(item.CreatedAt)
      }
    })
    list.value = data
  }else{
    return  ElMessage.warning("获取列表失败")
  }
}
// 页码改变
const handleSizeChange = (event) => {
  if(params.pageSize !==event){
    params.current = 1
    params.pageSize = event
    getList()
  }
}
const handleCurrentChange = ()=>{
  getList()
}

// 导出
const handleExport =async ()=>{
  const res = await exportTeams(params)
  if(res.err_code===0 && res.data){
    const filesName = `参赛队伍.xlsx`
    downLoadWithoutBaseUrl(res.data,filesName)
  }else{
    ElMessage.warning("无法下载")
  }
}
</script>

<style scoped lang="scss">
.search--box{
  width: 100%;
  height: 60px;
  overflow-x: scroll;
  display: flex;

}
.search--box{
  ::v-deep .el-form-item__label{
    padding: 0 !important;
  }
}
//::v-deep .search--box .el-form-item__label{
//  padding: 0 5px 0 0 !important;
//}
///deep/  .search--box .el-form-item__label{
//  padding: 0 5px 0 0 !important;
//}

</style>
